import { render, staticRenderFns } from "./Lgx243089040755130368.vue?vue&type=template&id=2cb9c2f6&scoped=true&"
import script from "./Lgx243089040755130368.vue?vue&type=script&lang=js&"
export * from "./Lgx243089040755130368.vue?vue&type=script&lang=js&"
import style0 from "./Lgx243089040755130368.vue?vue&type=style&index=0&id=2cb9c2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb9c2f6",
  null
  
)

export default component.exports